import $ from 'jquery';
import { Direction, IModData } from './interface';

const ReOrderTemplate = require('./views/reorder.handlebars');
const BASE_SELECTOR: string = '[data-mod]';
const INSTALL_BUTTON_SELECTOR: string = '[data-install]';
const UNINSTALL_BUTTON_SELECTOR: string = '[data-uninstall]';
const AVAILABLE_MODS_WRAPPER: string = '[data-mods-available]';
const INSTALLED_MODS_WRAPPER: string = '[data-mods-installed]';
const REORDER_WRAPPER_SELECTOR: string = '[data-reorder-wrapper]';
const REORDER_UP_BUTTON_SELECTOR: string = '[data-reorder-up]';
const REORDER_DOWN_BUTTON_SELECTOR: string = '[data-reorder-down]';
const EMPTY_HINT_SELECTOR: string = '[data-empty-hint]'

export class ModUI {
  public active: boolean = false;
  private allowReorder: boolean = false;
  public installed: boolean = false;

  public constructor(public $base: JQuery, public orderPosition?: number) {
    const data : IModData = this.getData();
    this.active = data.active;
    this.installed = data.installed;
    this.allowReorder = data.allowReorder;
    this.toggleEmptyHint();
  }

  public isArma() : boolean {
    return $('.mod').first().find('.mod__install-type').length > 0 || typeof window.activatedModUrl === 'undefined';
  }

  public renderReorder() {
    if (this.active) {
      this.$base.find(REORDER_WRAPPER_SELECTOR).show().html(ReOrderTemplate({ position: this.$base.data('order') + 1 }));
    } else {
      this.hideReorderArrows();
    }
  }

  public hideReorderArrows() {
    this.$base.find(REORDER_WRAPPER_SELECTOR).empty();
  }

  public getData(): IModData {
    return this.$base.data('mod');
  }

  public setCallbackonInstallButtonClick(callback: () => {}) {
    this.$base.find(INSTALL_BUTTON_SELECTOR).off('click');
    this.$base.find(INSTALL_BUTTON_SELECTOR).on('click', () => callback());
    this.renderReorder();
  }

  public onMoveUpClick(callback: () => {}) {
    this.$base.find(REORDER_UP_BUTTON_SELECTOR).on('click', () => callback());
  }

  public onMoveDownClick(callback: () => {}) {
    this.$base.find(REORDER_DOWN_BUTTON_SELECTOR).on('click', () => callback());
  }

  public setCallbackonUninstallButtonClick(callback: () => {}) {
    this.$base.find(UNINSTALL_BUTTON_SELECTOR).off('click');
    this.$base.find(UNINSTALL_BUTTON_SELECTOR).on('click', () => callback());
  }

  public setCallbackOnCheckboxToggle(onActivate: () => {}, onDeactivate: () => {}) {
    const index = this.$base.find('.fancy-checkbox input').data('index');
    if (typeof window.checkboxes !== 'undefined' && typeof window.checkboxes[index] !== 'undefined') {
      window.checkboxes[index].onChange = () => {
        if (this.active === true) {
          onDeactivate();
          this.active = false;
        } else {
          onActivate();
          this.active = true;
        }
      }
    }
  }

  public countInstalledMods() : number {
    return $(INSTALLED_MODS_WRAPPER).find('.mod').length;
  }

  public getModTypeValue() {
    return typeof this.$base.find('input[type="radio"]:checked').val() === 'undefined' ? 'clientMod' : this.$base.find('input[type="radio"]:checked').val();
  }

  public disableInstallButton() {
    this.$base.find(INSTALL_BUTTON_SELECTOR).attr('disabled', 'disabled');
  }

  public enableInstallButton() {
    this.$base.find(INSTALL_BUTTON_SELECTOR).removeAttr('disabled');
  }

  public disableUninstallButton() {
    this.$base.find(UNINSTALL_BUTTON_SELECTOR).attr('disabled', 'disabled');
  }

  public enableUninstallButton() {
    this.$base.find(UNINSTALL_BUTTON_SELECTOR).removeAttr('disabled');
  }

  public moveToInstalled(callback: () => {}) {
    this.$base.appendTo($(INSTALLED_MODS_WRAPPER));
    this.$base.find(INSTALL_BUTTON_SELECTOR).addClass('button--danger').text('Remove').removeAttr('data-install').attr('data-uninstall', '');
    if (this.$base.data('activatable')) {
      this.$base.find('[data-activate]').html('<div class="fancy-checkbox"><input type="checkbox" value="0"/> <label>Active</label></div>');
    } else {
      this.$base.find('[data-activate]').html('Select the map/total conversion in the basic settings');
    }
    this.installed = true;
    this.renderReorder();
    this.toggleEmptyHint();
    callback();
  }

  public toggleEmptyHint() {
    if (this.countInstalledMods() > 0) {
      $(EMPTY_HINT_SELECTOR).hide();
    } else {
      $(EMPTY_HINT_SELECTOR).show();
    }
  }

  public moveToAvailable(callback?: () => {}) {
    this.$base.prependTo($(AVAILABLE_MODS_WRAPPER));
    this.$base.find(UNINSTALL_BUTTON_SELECTOR).removeClass('button--danger').text('Install').removeAttr('data-uninstall').attr('data-install', '');
    this.$base.find('.fancy-checkbox').remove();
    this.installed = false;
    this.renderReorder();
    this.toggleEmptyHint();
    if (callback) {
      callback();
    }
  }

  static setCallbackOnActivateAll(callback: () => {}) {
    $('[data-activate-all]').on('click', () => {
      callback();
    });
  }

  static setCallbackOnDeactivateAll(callback: () => {}) {
    $('[data-deactivate-all]').on('click', () => {
      callback();
    });
  }

  public activateCheckboxForActiveMods(mods: string[]) {
    if (Array.isArray(mods)) {
      const active = mods.filter((item) => item === this.getData().modid);
      if (active.length > 0) {
        this.active = true;
        if (!this.isArma()) {
          this.disableUninstallButton();
        }
        const index = this.$base.find('.fancy-checkbox input').data('index');
        if (typeof window.checkboxes[index] !== 'undefined') {
          window.checkboxes[index].setActive();
        }
      }
    }
  }

  public getCheckboxIndex() {
    return this.$base.find("input[data-index]").data('index');
  }
}

export function createModUIInstances(): ModUI[] {
  const $base = $(BASE_SELECTOR);
  const instances: ModUI[] = [];

  $base.each((i, el) => {
    instances.push(new ModUI($(el), i ));
  });

  return instances;
}
